module.exports = __webpack_public_path__ + "02_short_gold.c516535f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_short_gold.png
// module id = YGzo
// module chunks = 0